import React, { useContext, useEffect, useState } from 'react';
import Remove from "../../../../../assets/Icon/TimeB"; 
import cl from './EditCargo.module.css';
import USD from "../../../../../assets/Icon/USD";
import Check from "../../../../../assets/Icon/Check"; 

import { AppContext } from '../../../../../providers/appProvider';
import { useClient } from '../../../../../hooks/useClient'; 

const EditCargoModal = ({ cargoService, containerService,defaultCargo, defaultContainer, onCloseEditCargo  }) => {

    const { clientService } = useClient(-1);

    const cargoResetData = {
        name: defaultCargo.name,
        personal: defaultCargo.personal,
        email: defaultCargo.email,
        mobile: defaultCargo.mobile, 
        car_info: defaultCargo.car_info,
        other_info: defaultCargo.other_info,
        cargo_price: defaultCargo.cargo_price,
        vin: defaultCargo.vin,
        container_id: defaultContainer.id,
        id: defaultCargo.id
    }
 
    const [searchClients, setSearchClient] = useState([])
 

    const handleInputChange = async (e, index) => {
        const { name, value } = e.target;
        var carTmp = cargo
        carTmp[name] = value;
        setCargo(carTmp); 
        setSearchClient([])
    };



    const handleInputInt = async (e, index) => {
        const { name, value } = e.target;
        var carTmp = cargo
        carTmp[name] = parseInt(value, 10); 
        setCargo(carTmp);
        setSearchClient([]);
    };


    const handleClientClick = (idx) => {
        var client = searchClients[idx]
        var carTmp = cargo
  
        carTmp.client = client; 
        carTmp.client_id = client.id
        setCargo(carTmp);
        setSearchClient([])

        
    };

    const [cargo, setCargo] = useState(cargoResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);



    const validateCargo = (cargo) => {
        const messages = {};
  
        if (cargo.vin.length < 2) {
            messages['name'] = { message: 'მიუთითეთ სახელი გვარი', isValid: false };
        }

        if (cargo.vin.length < 2) {
            messages['vin'] = { message: 'მიუთითეთ ვინ-კოდი', isValid: false };
        }

        if (cargo.car_info.length < 2) {
            messages['car_info'] = { message: 'შეავსეთ ავტომობილის მონაცემები', isValid: false };
        }

        /*
        if (cargo.other_info.length < 2) {
            messages['other_info'] = { message: 'შეავსეთ დამატებითი ინფორმაცია', isValid: false };
        }

        if (cargo.cargo_price < 1) {
            messages['cargo_price'] = { message: 'მიუთითეთ თანხა', isValid: false };
        }
        */


 
       /*


        if( cargo.cargo_price > maxPrice ) {
             messages['maxPriceCargo'] = { message: 'გადასახდელი აჭარბებს კლიენტების გადასახდელის ჯამს' , isValid: false };
           app.setError('გადასახდელი აჭარბებს კლიენტების გადასახდელის ჯამს');

        }
        */


 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateCargo(cargo)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateCargo(cargo)
        }
    }, [cargo, isFirstValidated]);

 
    const saveHandle = () => {

  

        const isValidate = validateCargo(cargo)
        
        if (isValidate === true) {
            cargoService.update(cargo)
            .then(data => {
                containerService.fetchList()
                onCloseEditCargo()    
                //app.setOk(successMessage); 
            })
            .catch(errorMessage => {

                console.error('შეცდომა:', errorMessage);
                if (errorMessage.includes("email")) {
                    app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                } else if (errorMessage.includes("mobile")) {
                    app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                } else if (errorMessage.includes("unique vin")) {
                    app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                } else {
                    app.setError("შეცდომა: " + errorMessage);
                }


            });
 
        } else {
         setIsFirstValidated(true)
        }
   
    };
 
    const openAdd = () => {
        setValidates({})
        onCloseEditCargo()
        setIsFirstValidated(false)
        setCargo(cargoResetData)
     }



     const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; 
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
    };


    const handleFocusCargo = async (e) => {
        const { name, value } = e.target; 
        if (value === '0') {
            e.target.value = '';
        }
    };



    const handleBlurCargo = async (e) => {
        const { name, value } = e.target; 
        if (value === '') {
            let val = convertToInt(0); 
            e.target.value = val;
        } 
    };



    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }


    return (<tr className={cl.tr}>
            
                  
                <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', position: 'relative' }} >
                        <div className={ validates && validates['name'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                            <input type="textS" className={ cl.input }  name="name" value={cargo.name} 
                                onChange={(e) => handleInputChange(e)}
                                onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                            }} /> 
                        </div>  
                    </div>
                </td>

                <td>
                    <div className={ validates && validates['personal'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput }>
                        <input type="textS" className={ cl.input } name="personal" value={cargo.personal} 
                            onChange={(e) => handleInputChange(e)}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}  /> 
                    </div>
                </td>

                <td>  
                    <div className={validates && validates['mobile'] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input} name="mobile" value={cargo.mobile} 
                            onChange={(e) => handleInputChange(e)}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}  />                                    
                    </div>
                </td>

                


                <td>
                    <div className={validates && validates[`car_info`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        name="car_info" value={cargo.car_info} onChange={(e) => handleInputChange(e)}   />
                    </div>
                </td>

                <td>
                    <div className={validates && validates[`vin`] ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <input type="textS" className={cl.input}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                        }}
                        name="vin" value={cargo.vin} onChange={(e) => handleInputChange(e)}  />
                    </div>
                </td>
  
                <td style={{ maxWidth: '85px' }}>      
                    <div className={  validates && validates[`cargo_price`] ? cl.groupInput + ' ' + cl.dollar  + ' ' + cl.blue + ' ' + cl.errorInput : cl.groupInput + ' ' + cl.dollar  + ' ' + cl.blue} style={{maxWidth:'75px'}}> 
                        <div className={cl.groupInputIcon}>
                            <div className={cl.crmIcon}><USD/></div>
                            <input type="textS" className={cl.input}  name="cargo_price" value={cargo.cargo_price}
                                onKeyPress={handleKeyPress}   
                                onFocus={handleFocusCargo}
                                onBlur={handleBlurCargo }
                                disabled={!app.hasPermission("TRANSPORT_PRICE_EDIT_CLIENT_CARGO")}
                                onChange={(e) => handleInputInt(e)} />
                        </div>
                    </div>
                </td>
  
                 
 
                <td style={{ maxWidth: '85px' }}>      
                    <div className={ cl.groupInput + ' ' + cl.dollar    } style={{ maxWidth: '75px', display: 'none'  }}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" disabled className={cl.input} value={ 0 } />
                            <div className={cl.crmIcon}><USD/></div>
                        </div> 
                    </div>  
                </td>



                <td style={{ maxWidth: '85px' }}>      
                    <div className={ cl.groupInput + ' ' + cl.dollar  } style={{ maxWidth: '75px', display: 'none' }}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS" disabled className={cl.input} value={ 0 } />
                            <div className={cl.crmIcon}><USD/></div>
                        </div> 
                    </div>  
                </td>




                <td>
                    <span className={cl.AddBtnCargo}>
                        <span  onClick={saveHandle} >
                            <Check/>
                        </span>

                        <span onClick={onCloseEditCargo} className={ cl.removeBtn } >
                            <Remove/>
                        </span> 

                    </span>
                </td>
            
             
        </tr>
    );
};

export default EditCargoModal;